export default __webpack_public_path__ + "static/media/bdHomeLarge.e619e93e.png";